import React, {useState, useEffect, useRef} from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import SelectInfinite from '../../components/FormFields/SelectInfinite';
import InputText from '../../components/FormFields/InputText';
import TextArea from '../../components/FormFields/Textarea';
import * as yup from 'yup';
import {getLanguage, t} from 'react-switch-lang';
import {Col, Row} from 'react-bootstrap';
import {
  editPotentialRisk,
  getRiskFile,
  getRiskEstimations,
  getDepartment,
} from '../../services/potentialRiskService';
import './PotentialRisk.scss';
import {useUserContext} from '../../contexts/UserContext';
import Toast from '../../components/toast/Toast';
import 'antd/dist/antd.css';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import allowedFileTypes from '../../utils/allowedFileTypes';
import {ReactComponent as PlusImg} from './img/PlusLightBlue.svg';
import {useHistory} from 'react-router-dom';
import InputDate from '../../components/FormFields/inputDate/InputDate';
import PreventTransitionPrompt from '../../components/preventTransitionprompt/PreventTransition';
import FileUploadSection from '../../components/FileUploadSection/FileUploadSection';
import {appModules} from '../../utils/const';
import {RISK_COLOR_MAP} from '../../utils/helpers';

const PotentialRisk = ({defaultData}) => {
  const lang = getLanguage();
  const user = useUserContext();
  const userDepartment = useDepartmentContext();
  const history = useHistory();
  const [userResponsibleLogin, setUserResponsibleLogin] = useState();
  const [disableSubprocess, setDisableSubPorcess] = useState(false);
  const [disableSubCause, setDisableSubCause] = useState(true);
  const [disableSubCategory, setDisableSubCategory] = useState(true);
  const [disableRiskCause, setDisableRiskCause] = useState(true);
  const disableRiskEstimation = true;
  const [loading, setLoading] = useState(false);
  const [riskEstimation, setRiskEstimation] = useState(
    lang === 'eng'
      ? defaultData?.riskEstimationEvaluationEn
      : defaultData?.riskEstimationEvaluation,
  );
  const [riskEstimationId, setRiskEstimationId] = useState(
    defaultData?.riskEstimationId,
  );
  const [riskEstimationColor, setRiskEstimationColor] = useState(
    defaultData?.riskEstimationColor,
  );
  const [renderRiskSubCategory, setRenderRiskSubCategory] = useState(true);
  const [riskSubCategoryRenderKey, setRiskSubCategoryRenderKey] = useState(0);
  const [disabledRisk, setDisabledRisk] = useState(true);
  const [potentialRisk, setPotentialRisk] = useState({
    id: defaultData.id,
    riskStatusId: defaultData.riskStatusId,

    ...(defaultData.potentialRiskTypeId !== null
      ? {
        potentialRiskType: {
          value:
            defaultData.potentialRiskTypeId !== null
              ? defaultData.potentialRiskTypeId
              : null,
          label:
            defaultData.potentialRiskTypeId !== null
              ? lang === 'eng'
                ? defaultData.potentialRiskTypeNameEn
                : defaultData.potentialRiskTypeName
              : null,
        },
      }
      : {potentialRiskType: null}),

      ...(defaultData?.externalizationId !== null
      ? {
        externalizationId: {
          value:
            defaultData?.externalizationId !== null
              ? defaultData?.externalizationId
              : null,
          label:
            defaultData?.externalizationContractSubject !== null
              ? defaultData?.externalizationContractSubject
              : null,
        },
      }
      : {externalizationId: null}),
    title: defaultData.title,
    description: defaultData.description,
    ...(defaultData.riskCauseId !== null
      ? {
        riskCause: {
          value: defaultData.riskCauseId,
          label:
            lang === 'eng'
              ? defaultData.riskCauseNameEn
              : defaultData.riskCauseName,
        },
      } : {riskCause: null}),
    ...(defaultData.riskCategoryId !== null
      ? {
        riskCategory: {
          value: defaultData.riskCategoryId,
          label:
            lang === 'eng'
              ? defaultData.riskCategoryNameEn
              : defaultData.riskCategoryName,
        },
      } : {riskCategory: null}),
    ...(defaultData.subcategoryId !== null
      ? {
        riskSubCategory: {
          value: defaultData.subcategoryId,
          label:
            lang === 'eng'
              ? defaultData.subcategoryNameEn
              : defaultData.subcategoryName,
        },
      }
      : {riskSubCategory: null}),
    ...(defaultData.processId !== null
      ? {
        processId: {
          value: defaultData.processId,
          label:
            lang === 'eng'
              ? defaultData.processNameEn
              : defaultData.processName,
        },
      }
      : {processId: null}),
        subprocessId: {
          value: defaultData.subprocessId,
          label:
            lang === 'eng'
              ? defaultData.subprocessNameEn
              : defaultData.subprocessName,
        },
    ...(defaultData.businessLineId !== null
      ? {
        businessLine: {
          value: defaultData.businessLineId,
          label:
            lang === 'eng'
              ? defaultData.businessLineNameEn
              : defaultData.businessLineName,
        },
      }
      : {businessLine: null}),
    // methodology: {
    //   value: defaultData.methodologyId,
    //   label:
    //     lang === 'eng'
    //       ? defaultData.methodologyNameEn
    //       : defaultData.methodologyName,
    // },
    departmentStakeholder: {
      value: defaultData.departmentStakeholderId,
      label:
        lang === 'eng'
          ? defaultData.departmentStakeholderNameEn
          : defaultData.departmentStakeholderName,
    },
    comment: defaultData.comment,
    files: defaultData.files,
    userInChargeRisk:
      defaultData.userInChargeFirstName +
      ' ' +
      defaultData.userInChargeLastName,
    responsibleUserRisk:
      defaultData.userResponsibleFirstName +
      ' ' +
      defaultData.userResponsibleLastName,
    financialPerformance: {
      value: defaultData.financialPerformanceId,
      label:
        lang === 'eng'
          ? defaultData.financialPerformanceNameEn
          : defaultData.financialPerformanceName,
    },
    frequencyOccurenceRisk: {
      value: defaultData.frequencyOccurenceRiskId,
      label:
        lang === 'eng'
          ? defaultData.frequencyOccurenceRiskNameEn
          : defaultData.frequencyOccurenceRiskName,
    },
    riskEstimationEvaluation: defaultData.riskEstimationEvaluation,
    riskEstimationId: defaultData.riskEstimationId,
    riskEstimationColor: defaultData.riskEstimationColor,
    riskSubCause: {
      value: defaultData.riskSubCauseId,
      label:
        lang === 'eng'
          ? defaultData.riskSubCauseNameEn
          : defaultData.riskSubCauseName,
    }
  });
  const [files, setFiles] = useState([]);
  const [deleteFiles, setDeleteFiles] = useState([]);
  const prevProcessIdRef = useRef(null);
  const prevCauseIdRef = useRef(null);
  const prevCategoryIdRef = useRef(null);
  const [renderAfter, setRenderAfter] = useState(0)

  const [schema, setSchema] = useState(
    yup.object().shape({
      title: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(150, t('message.max', {max: 150})),
      potentialRiskType: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      description: yup
        .string()
        .trim()
        .required(t('message.fieldRequired'))
        .max(2048, t('message.max', {max: 2048})),
      riskCause: yup.object().nullable().required(t('message.fieldRequired')),
      riskSubCause: yup.object().nullable().required(t('message.fieldRequired')),
      riskCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskSubCategory: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      processId: yup.object().nullable().required(t('message.fieldRequired')),
      subprocessId: yup.object().nullable().required(t('message.fieldRequired')),
      businessLine: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      // methodology: yup.object().nullable().required(t('message.fieldRequired')),
      departmentStakeholder: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      frequencyOccurrenceOr: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      financialPerformance: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      riskMitigationModeName: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
      comment: yup
        .string()
        .trim()
        .max(2048, t('message.max', {max: 2048})),
      departmentSourceId: yup
        .object()
        .nullable()
        .required(t('message.fieldRequired')),
    }),
  );

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue, reset} = methods;
  const watchProcess = watch('processId');
  const watchFrequencyOccurrenceOr = watch('frequencyOccurrenceOr');
  const watchFinancialPerformance = watch('financialPerformance');
  const watchRiskCause = watch('riskCause');
  const watchDepartmentSourceId = watch('departmentSourceId');
  const watchRiskCategory = watch('riskCategory');
  const watchRiskType = watch('potentialRiskType')
  const watchRiskSubCategory = watch('riskSubCategory');
  const fetchRiskEstimation = async () => {
    try {
      const {data} = await getRiskEstimations(
        watchFrequencyOccurrenceOr['value'],
        watchFinancialPerformance['value'],
      );
      return data;
    } catch (e) {
    }
  };

  useEffect(() => {
    window.location.pathname.includes('edit')
      ? setDisabledRisk(false)
      : setDisabledRisk(true);
  }, []);

  const handleCancel = (e) => {
    e.preventDefault();
    window.location = `/potential-risk/${defaultData.id}`;
  };

  const submitForm = async (data) => {
    const files = document.getElementById('upload').files;
    const payload = {
      id: parseInt(potentialRisk.id),
      riskStatusId: potentialRisk.riskStatusId,
      applicationDate: new Date(defaultData.applicationDate),
      title: data.title,
      potentialRiskTypeId: data.potentialRiskType.value,
      description: data.description,
      riskCauseId: data.riskCause.value,
      riskSubCauseId: data.riskSubCause.value,
      riskCategoryId: data.riskCategory.value,
      subcategoryId: data.riskSubCategory?.value,
      riskTypeId: 1,
      userCreatedId: user.id,
      userInChargeId: user.id,
      userInChargeLogin: user.login,
      userResponsibleId: data.userResponsible.value,
      userResponsibleLogin: userResponsibleLogin,
      processId: data?.processId?.value,
      subprocessId: data?.subprocessId?.value,
      businessLineId: data.businessLine.value,
      // methodologyId: data.methodology.value,
      departmentStakeholderId: data.departmentStakeholder.value,
      departmentSourceId: data.departmentSourceId.value,
      riskEstimationId: riskEstimationId,
      riskMitigationModeId: data?.riskMitigationModeName?.value,
      riskMitigationModeName: data?.riskMitigationModeName?.label,
      comment: data.comment,
      deleteFiles: deleteFiles,
      externalizationId: data?.externalizationId?.value
    };
    setLoading(true);
    try {
      const response = await editPotentialRisk(payload, files);
      if (response.status === 200) {
        await Toast.fire({
          title: t('potentialRisk.messages.editSuccess'),
          icon: 'success',
        });
      }
      window.location = `/potential-risk/${parseInt(potentialRisk.id)}`;

    } catch (err) {
      if (err.response.data.code === 'risk-exists') {
        Toast.fire({
          title:
            lang === 'eng'
              ? err.response.data.description
              : t('potentialRisk.messages.addErrorExists'),
          icon: 'error',
        });
        document.getElementById('title').focus();
        document.getElementById('title').select();
      } else {
        reset();
        setValue('process', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        setValue('subprocess', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
        Toast.fire({
          title: t('potentialRisk.messages.editError'),
          icon: 'error',
        });
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const newProcessId = watchProcess?.value ?? null;
    const prevProcessId = prevProcessIdRef.current;
    setRenderAfter(renderAfter + 1);
    if (watchProcess && !window.location.pathname.includes('edit')) {
        setDisableSubPorcess(true);
    }
    else if (watchProcess && window.location.pathname.includes('edit')) {
      if (renderAfter >= 3) {
        setDisableSubPorcess(false);
        setValue('subprocessId', '', {
          shouldValidate: false,
          shouldDirty: false,
        });
      }
    }
    else if (watchProcess === null) {
      setDisableSubPorcess(true);
      setValue('subprocessId', '', {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
    if (watchProcess !== null && prevProcessId !== null && prevProcessId !== newProcessId) {
      setValue('subprocessId', '', {shouldValidate: false, shouldDirty: true});
      setDisableSubPorcess(false);
    }
    prevProcessIdRef.current = newProcessId;
  }, [watchProcess]);

  // useEffect(() => {
  //   const newCauseId = watchRiskCause?.value ?? null;
  //   const prevCauseId = prevCauseIdRef.current;
  //   setRenderAfter(renderAfter + 1);
  //   if (watchRiskCause && !window.location.pathname.includes('edit')) {
  //     setDisableSubCause(true)
  //   }
  //   if (watchRiskCause && window.location.pathname.includes('edit')) {
  //     if (renderAfter >= 3) {
  //       setDisableSubCause(false)
  //       setValue('riskSubCause', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //     }
  //   }
  //     if (watchRiskCause === null) {
  //       setDisableSubCause(true);
  //       setValue('riskSubCause', '', {
  //         shouldValidate: false,
  //         shouldDirty: false,
  //       });
  //     }
  //     if (watchRiskCause !== null && prevCauseId !== null && prevCauseId !== newCauseId) {
  //       setValue('riskSubCause', '', {shouldValidate: false, shouldDirty: true});
  //       setDisableSubCause(false);
  //     }
  //     prevCauseIdRef.current = newCauseId;
  // }, [watchRiskCause]);
  useEffect(() => {
    const newCauseId = watchRiskCause?.value ?? null;
    const prevCauseId = prevCauseIdRef.current;

    if (disabledRisk) {
      setDisableSubCause(true);
      prevCauseIdRef.current = newCauseId;
      return;
    }

    if (newCauseId) {
      setDisableSubCause(false);
    } else {
      setDisableSubCause(true);
      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }

    if (
      newCauseId !== null &&
      prevCauseId !== null &&
      prevCauseId !== newCauseId
    ) {
      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setDisableSubCause(false);
    }

    prevCauseIdRef.current = newCauseId;
  }, [watchRiskCause, disabledRisk, setValue]);

  // useEffect(() => {
  //   const newCategoryId = watchRiskCategory?.value ?? null;
  //   const prevCategoryId = prevCategoryIdRef.current;
  //   if (watchRiskCategory && !window.location.pathname.includes('edit')) {
  //     setDisableSubCategory(true)
  //   }
  //   if (watchRiskCategory === null) {
  //     setDisableSubCategory(true);
  //     setPotentialRisk((prev) => ({
  //       ...prev,
  //       riskSubCategory: null,
  //     }));
  //     setValue('riskSubCategory', null, {
  //       shouldValidate: false,
  //       shouldDirty: false,
  //     });
  //   }
  //
  //   if (
  //     watchRiskCategory !== null &&
  //     prevCategoryId !== null &&
  //     prevCategoryId !== newCategoryId
  //   ) {
  //     setDisableSubCategory(false);
  //
  //     setPotentialRisk((prev) => ({
  //       ...prev,
  //       riskSubCategory: null,
  //     }));
  //
  //     setValue('riskSubCategory', null, {
  //       shouldValidate: false,
  //       shouldDirty: true,
  //     });
  //
  //     setRenderRiskSubCategory(false);
  //
  //     setTimeout(() => {
  //       setRiskSubCategoryRenderKey((prev) => prev + 1);
  //       setRenderRiskSubCategory(true);
  //     }, 0);
  //   }
  //
  //   if (
  //     watchRiskCategory &&
  //     window.location.pathname.includes('edit') &&
  //     (prevCategoryId === null || prevCategoryId === newCategoryId)
  //   ) {
  //     setDisableSubCategory(false);
  //   }
  //
  //   prevCategoryIdRef.current = newCategoryId;
  // }, [watchRiskCategory, setValue]);
  useEffect(() => {
    if (disabledRisk) {
      setDisableSubCategory(true);
      setDisableRiskCause(true);
      setDisableSubCause(true);
      return;
    }

    setDisableSubCategory(!watchRiskCategory?.value);
    setDisableRiskCause(!(watchRiskCategory?.value && watchRiskSubCategory?.value));
    setDisableSubCause(!watchRiskCause?.value);
  }, [disabledRisk, watchRiskCategory, watchRiskSubCategory, watchRiskCause]);
  useEffect(() => {
    const newCategoryId = watchRiskCategory?.value ?? null;
    const prevCategoryId = prevCategoryIdRef.current;

    if (disabledRisk) {
      setDisableSubCategory(true);
      prevCategoryIdRef.current = newCategoryId;
      return;
    }

    if (newCategoryId) {
      setDisableSubCategory(false);
    } else {
      setDisableSubCategory(true);
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setPotentialRisk((prev) => ({
        ...prev,
        riskSubCategory: null,
        riskCause: null,
        riskSubCause: null,
      }));

      setValue('riskSubCategory', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }

    if (
      newCategoryId !== null &&
      prevCategoryId !== null &&
      prevCategoryId !== newCategoryId
    ) {
      setDisableSubCategory(false);
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setPotentialRisk((prev) => ({
        ...prev,
        riskSubCategory: null,
        riskCause: null,
        riskSubCause: null,
      }));

      setValue('riskSubCategory', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: true,
      });
      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: true,
      });

      setRenderRiskSubCategory(false);

      setTimeout(() => {
        setRiskSubCategoryRenderKey((prev) => prev + 1);
        setRenderRiskSubCategory(true);
      }, 0);
    }

    prevCategoryIdRef.current = newCategoryId;
  }, [watchRiskCategory, disabledRisk, setValue]);
  useEffect(() => {
    if (disabledRisk) {
      setDisableRiskCause(true);
      return;
    }

    if (watchRiskCategory?.value && watchRiskSubCategory?.value) {
      setDisableRiskCause(false);
    } else {
      setDisableRiskCause(true);
      setDisableSubCause(true);

      setPotentialRisk((prev) => ({
        ...prev,
        riskCause: null,
        riskSubCause: null,
      }));

      setValue('riskCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
      setValue('riskSubCause', null, {
        shouldValidate: false,
        shouldDirty: false,
      });
    }
  }, [watchRiskCategory, watchRiskSubCategory, disabledRisk, setValue]);
  const getRiskColor = (risk) => {
    setRiskEstimationColor(RISK_COLOR_MAP[risk?.color] || '#000');
  };


  useEffect(() => {
    if (watchFrequencyOccurrenceOr?.value && watchFinancialPerformance?.value) {
      fetchRiskEstimation().then((r) => {
        const risk = r[0];
        if (risk.evaluation !== riskEstimation) {
          setRiskEstimation(
            lang === 'eng' ? risk.evaluationEn : risk.evaluation,
          );
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        } else {
          setRiskEstimation('');
          setRiskEstimation(riskEstimation);

          setRiskEstimationColor('');
          getRiskColor(risk);
          setRiskEstimationId(risk.id);
        }
      });
    }
    setValue('riskEstimation', '');
    if (
      watchFrequencyOccurrenceOr === null ||
      watchFinancialPerformance === null
    ) {
      setRiskEstimation('');
      setRiskEstimationColor('');
      setRiskEstimationId();
    }
  }, [watchFrequencyOccurrenceOr, watchFinancialPerformance]);

  const clearFetchedFile = (id) => {
    let children = potentialRisk.files.filter((file) => file.id !== id);
    setPotentialRisk({...potentialRisk, ['files']: children});
    setDeleteFiles([...deleteFiles, id]);
  };

  const toAddIncurred = () => {
    history.push({
      pathname: `/incurred-risk/add`,
      state: {potentialId: defaultData.id, potentialTitlе: defaultData.title},
    });
  };

  useEffect(() => {
    if (watchDepartmentSourceId) {
      const depratmentObject = async () => {
        try {
          const {data} = await getDepartment(watchDepartmentSourceId.value);
          setUserResponsibleLogin(data[0]?.userResponsibleLogin);
          setValue('userResponsible', {
            value: data[0].userResponsibleId,
            label:
              data[0].userResponsibleFirstName +
              ' ' +
              data[0].userResponsibleLastName,
          });
        } catch {
        }
      };
      depratmentObject();
    }
  }, [watchDepartmentSourceId]);

  return (
    <>
      {defaultData !== undefined && (
        <>
          <PreventTransitionPrompt when={!disabledRisk} />
          <div className='form mt-4 w-100 pb-4'>
            <div className='mt-4'>
              {defaultData?.active === true && user.authorities.includes('ROLE_USER_IN_CHARGE') && (
                <Row className='mb-2 justify-content-end px-3'>
                  <button
                    type='button'
                    className='secondary-btn float-right'
                    onClick={toAddIncurred}
                  >
                    <PlusImg />
                    <span className='ml-2'>
                      {t('navbar.resultingAdverseEvent')}
                    </span>
                  </button>
                </Row>
              )}

              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(submitForm)}>
                  <Row className='field-group-title'>
                    <Col className='col-4 col-xl-2'>
                      {t('potentialRisk.mainData')}
                    </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col className='col-6 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.title')}
                      </label>
                      <InputText
                        type='text'
                        name='title'
                        className='form-control input-field'
                        placeholder={t('potentialRisk.placeholder.title')}
                        defaultValue={potentialRisk.title}
                        disabled={disabledRisk}
                        id='title'
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.potentialRiskType')}
                      </label>
                      <SelectInfinite
                        api='potential-risk-types'
                        name='potentialRiskType'
                        placeholder={t(
                          'potentialRisk.placeholder.potentialRiskType',
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        defaultValue={potentialRisk.potentialRiskType}
                        isDisabled={disabledRisk}
                      />
                      {watchRiskType?.value === 2 && <>
                        <label className="label-potential-risk">
                          {t('externalization.externalization')}
                        </label>
                        <span className="optional register">
                  {t('common.optional')}
                </span>
                        <SelectInfinite
                          api="externalizations"
                          name="externalizationId"
                          placeholder={t('externalization.placeholder.externalization')}
                          labelKey={'contractSubject'}
                          className="select"
                          isDisabled={disabledRisk}
                          defaultValue={potentialRisk?.externalizationId}
                          queryKeys={'search.contains'}
                          isLink={true}
                          onClickLink={(option) => {
                            history.push(`/externalizations/${option.value}`);
                          }}
                        />
                      </>}
                    </Col>
                    <Col className='col-6 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.description')}
                      </label>
                      <TextArea
                        name='description'
                        className={`form-control text-area `}
                        placeholder={t('potentialRisk.placeholder.description')}
                        disabled={disabledRisk}
                        defaultValue={potentialRisk.description}
                      />
                    </Col>
                  </Row>
                  <Row className='mt-5 field-group-title'>
                    <Col className='col-6 col-xl-3'>
                      {t('potentialRisk.additionalInformation')}
                    </Col>
                  </Row>
                  <Row className='mt-2'>
                    <Col className='col-3 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.riskCategory')}
                      </label>
                      <SelectInfinite
                        api='risk-categories?active.equals=true'
                        name='riskCategory'
                        placeholder={t('potentialRisk.placeholder.riskCategory')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk?.riskCategory}
                        isDisabled={disabledRisk}
                      />

                      <label className='label-potential-risk'>
                        {t('potentialRisk.riskSubCategory')}
                      </label>
                      {renderRiskSubCategory && (
                        <SelectInfinite
                          api={
                            watchRiskCategory?.value !== undefined
                              ? `/risk-subcategories?riskCategoryId.equals=${watchRiskCategory?.value}&active.equals=true`
                              : `/risk-subcategories?riskCategoryId.equals=1&active.equals=true`
                          }
                          name='riskSubCategory'
                          placeholder={t('potentialRisk.placeholder.riskSubCategory')}
                          key={`riskSubCategory-${watchRiskCategory?.value || 'empty'}-${riskSubCategoryRenderKey}`}
                          className='select'
                          defaultValue={potentialRisk?.riskSubCategory ?? null}
                          isDisabled={disabledRisk || disableSubCategory}
                        />
                      )}
                      <label className='label-potential-risk'>
                        {t('potentialRisk.riskCause')}
                      </label>
                      <SelectInfinite
                        key={`riskCause-${watchRiskSubCategory?.value || 'empty'}`}
                        api={
                          watchRiskSubCategory?.value
                            ? `risk-causes?riskSubCategoryId.equals=${watchRiskSubCategory.value}`
                            : 'risk-causes'
                        }
                        name='riskCause'
                        placeholder={t('potentialRisk.placeholder.riskCause')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk.riskCause}
                        isDisabled={disabledRisk || disableRiskCause}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.riskSubCause')}
                      </label>
                      <SelectInfinite
                        api={
                          watchRiskCause?.value !== undefined
                            ? `/risk-sub-causes?riskCauseId.equals=${watchRiskCause?.value}&riskSubCategoryId.equals=${watchRiskSubCategory?.value}&active.equals=true`
                            : `/risk-sub-causes?riskCauseId.equals=1&active.equals=true`
                        }
                        name='riskSubCause'
                        placeholder={t('potentialRisk.placeholder.riskSubCause')}
                        key={watchRiskCause?.value}
                        className='select'
                        defaultValue={
                          potentialRisk?.riskSubCause !== undefined
                            ? potentialRisk?.riskSubCause
                            : ''
                        }
                        isDisabled={disabledRisk || disableSubCause}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.comment')}
                      </label>
                      <span className='optional register'>
                        {t('common.optional')}
                      </span>
                      <TextArea
                        name='comment'
                        className={`form-control text-area`}
                        placeholder={t('potentialRisk.placeholder.comment')}
                        disabled={disabledRisk}
                        defaultValue={
                          potentialRisk.comment ? potentialRisk.comment : ''
                        }
                      />
                    </Col>
                    <Col className='col-3 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.process')}
                      </label>
                      <SelectInfinite
                        api='processes?active.equals=true'
                        name='processId'
                        placeholder={t('potentialRisk.placeholder.process')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk?.processId}
                        isDisabled={disabledRisk}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.subprocess')}
                      </label>
                      <SelectInfinite
                        api={
                          watchProcess?.value !== undefined
                            ? `/subprocesses?processId.equals=${watchProcess?.value}&active.equals=true`
                            : `/subprocesses?processId.equals=1&active.equals=true`
                        }
                        name='subprocessId'
                        placeholder={t('potentialRisk.placeholder.subprocess')}
                        key={watchProcess?.value}
                        className='select'
                        defaultValue={
                          potentialRisk?.subprocessId !== undefined
                            ? potentialRisk?.subprocessId
                            : ''
                        }
                        isDisabled={disableSubprocess}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.businessLine')}
                      </label>
                      <SelectInfinite
                        api='business-lines'
                        name='businessLine'
                        placeholder={t(
                          'potentialRisk.placeholder.businessLine',
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk.businessLine}
                        isDisabled={disabledRisk}
                      />
                      {/*<label className='label-potential-risk'>*/}
                      {/*  {t('potentialRisk.methodology')}*/}
                      {/*</label>*/}
                      {/*<SelectInfinite*/}
                      {/*  api='methodologies'*/}
                      {/*  name='methodology'*/}
                      {/*  placeholder={t('potentialRisk.placeholder.methodology')}*/}
                      {/*  labelKey={lang === 'mne' ? 'name' : 'nameEn'}*/}
                      {/*  className='select'*/}
                      {/*  selected={potentialRisk.methodology}*/}
                      {/*  isDisabled={disabledRisk}*/}
                      {/*/>*/}
                      <label className='label-potential-risk' htmlFor={'attachFile'}>
                        {t('potentialRisk.attachFiles')}
                      </label>
                      <FileUploadSection
                        disabled={disabledRisk}
                        allowedFileTypes={allowedFileTypes}
                        fetchedFiles={potentialRisk.files}
                        onDeleteFetchedFile={clearFetchedFile}
                        onNewFilesChange={(newFiles) => setFiles(newFiles)}
                        onFileDownload={getRiskFile}
                      />
                    </Col>
                    <Col className='col-3 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.financialPerformance')}
                      </label>
                      <SelectInfinite
                        api='financial-performances?sort=id,desc'
                        name='financialPerformance'
                        placeholder={t(
                          'potentialRisk.placeholder.financialPerformance',
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk.financialPerformance}
                        isDisabled={disabledRisk}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.frequencyOccurrenceOr')}
                      </label>
                      <SelectInfinite
                        api='frequency-occurence-risks'
                        name='frequencyOccurrenceOr'
                        placeholder={t(
                          'potentialRisk.placeholder.frequencyOccurrenceOr',
                        )}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk.frequencyOccurenceRisk}
                        isDisabled={disabledRisk}
                      />
                      <label className='label-potential-risk'>
                        {t('potentialRisk.riskEstimation')}
                      </label>
                      {/*Can't use InputText component since it has ref register and color needs to change*/}
                      {/*passing !important trough another ref since react doesn't accept it in inline style as variable (#ffffff !important)*/}
                      <input
                        key={riskEstimationId}
                        className='form-control input-field'
                        value={riskEstimation?.toUpperCase()}
                        type='text'
                        disabled={disableRiskEstimation}
                        ref={(el) => {
                          if (el) {
                            el.style.setProperty(
                              'color',
                              riskEstimationColor,
                              'important',
                            );
                          }
                        }}
                      />
                      <label className='label-potential-risk'>
                        {t('mitigation-measures.method')}
                      </label>
                      <SelectInfinite
                        api='/risk-mitigation-modes'
                        name='riskMitigationModeName'
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        placeholder={t('placeholder.riskMitigrationMethod')}
                        isDisabled={disabledRisk}
                        defaultValue={defaultData.riskMitigationModeName ? {
                          label: defaultData.riskMitigationModeName,
                          value: defaultData.riskMitigationModeId,
                        } : null}
                      />
                    </Col>
                    <Col className='col-3 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('potentialRisk.departmentRisk')}
                      </label>
                      {userDepartment?.length > 1 ? (
                        <SelectInfinite
                          api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                          name='departmentSourceId'
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk',
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className='select'
                          isDisabled={disabledRisk}
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                        />
                      ) : (
                        <SelectInfinite
                          api={`departments/departments-user-in-charge?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                          name='departmentSourceId'
                          placeholder={t(
                            'potentialRisk.placeholder.departmentRisk',
                          )}
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className='select'
                          defaultValue={{
                            value: defaultData.departmentSourceId,
                            label:
                              lang === 'mne'
                                ? defaultData.departmentSourceName
                                : defaultData.departmentSourceNameEn,
                          }}
                          isDisabled={true}
                        />
                      )}
                      <label className='label-potential-risk'>
                        {t('potentialRisk.departmentStakeholder')}
                      </label>
                      <SelectInfinite
                        api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                        name='departmentStakeholder'
                        placeholder={t('potentialRisk.placeholder.departmentStakeholder')}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        selected={potentialRisk.departmentStakeholder}
                        isDisabled={disabledRisk}
                      />
                      {/* odgovorno lice */}
                      {userDepartment?.length === 1 ? (
                        <>
                          <label className='label-potential-risk'>
                            {t('potentialRisk.userResponsible')}
                          </label>
                          <SelectInfinite
                            api='users'
                            name='userResponsible'
                            labelKey='firstName'
                            placeholder={t(
                              'potentialRisk.placeholder.userResponsible',
                            )}
                            className='select'
                            isDisabled={true}
                            defaultValue={{
                              value:
                                userDepartment[0]?.id !== undefined
                                  ? userDepartment[0]?.userResponsibleId
                                  : '',
                              label:
                                userDepartment[0]?.id !== undefined
                                  ? userDepartment[0]?.userResponsibleFirstName +
                                  ' ' +
                                  userDepartment[0]?.userResponsibleLastName
                                  : '',
                            }}
                          />
                        </>
                      ) : (
                        <>
                          <label className='label-potential-risk'>
                            {t('potentialRisk.userResponsible')}
                          </label>
                          <SelectInfinite
                            api='users'
                            name='userResponsible'
                            labelKey='firstName'
                            placeholder={t(
                              'potentialRisk.placeholder.userResponsible',
                            )}
                            className='select'
                            isDisabled={true}
                          />
                        </>
                      )}
                      <label className='label-potential-risk'>
                        {t('incurred-risk.userInCharge')}
                      </label>
                      <SelectInfinite
                        api='users'
                        name='users'
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.userInChargeId,
                          label:
                            defaultData.userInChargeFirstName +
                            ' ' +
                            defaultData.userInChargeLastName,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row>
                  </Row>
                  <Row className='mt-4 field-group-title'>
                    <Col className='col-6 col-xl-3'>
                      {t('litigation.systemAddedInformation')}
                    </Col>
                  </Row>
                  <Row className='mb-2'>
                    <Col className='col-6 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('incurred-risk.id')}
                      </label>
                      <InputText
                        type='text'
                        name='id'
                        className='form-control input-field'
                        disabled={true}
                        defaultValue={defaultData?.id}
                      />
                    </Col>
                    <Col className='col-6 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('incurred-risk.date')}
                      </label>
                      <InputDate
                        name='creationDate'
                        className='form-control input-field'
                        selected={new Date(defaultData.applicationDate)}
                        disabled={true}
                      />
                    </Col>
                    <Col className='col-6 col-xl-3'>
                      <label className='label-potential-risk'>
                        {t('incurred-risk.status')}
                      </label>
                      <SelectInfinite
                        api='risk-statuses'
                        name='riskStatus'
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className='select'
                        isDisabled={true}
                        defaultValue={{
                          value: defaultData.riskStatusId,
                          label:
                            lang === 'mne'
                              ? defaultData.riskStatusName
                              : defaultData.riskStatusNameEn,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className='mb-3'>
                  </Row>
                  <div>
                    {!disabledRisk ? (
                      <Row className='form-footer w-100' key={disabledRisk}>
                        <button
                          className='secondary-btn'
                          type='reset'
                          onClick={handleCancel}
                        >
                          {t('buttons.cancel')}
                        </button>
                        <button disabled={loading} className='primary-btn'>
                          {t('buttons.save')}
                        </button>
                      </Row>
                    ) : null}
                  </div>
                </form>
              </FormProvider>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PotentialRisk;